import axios from 'axios';
//installed axios api to 'get' weather info

const API_Key = '56f7e43879b8899ddf407dd16996e3c5';
const API_URL = 'http://api.openweathermap.org/data/2.5/weather';

export const getWeather = async ( city, country) => {
    try {
        let response = await axios.get(`${API_URL}?q=${city},${country}&appid=${API_Key}&units=metric`);
        return response.data;
    } catch (error) {
        console.log('Error while calling the api', error.message);
        return error.response;
    }
}